import { render, staticRenderFns } from "./Epson.vue?vue&type=template&id=023f2fcf&scoped=true"
import script from "./Epson.vue?vue&type=script&lang=ts"
export * from "./Epson.vue?vue&type=script&lang=ts"
import style0 from "./Epson.vue?vue&type=style&index=0&id=023f2fcf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f2fcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023f2fcf')) {
      api.createRecord('023f2fcf', component.options)
    } else {
      api.reload('023f2fcf', component.options)
    }
    module.hot.accept("./Epson.vue?vue&type=template&id=023f2fcf&scoped=true", function () {
      api.rerender('023f2fcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/Epson.vue"
export default component.exports